import './assets/NcRichText-BKnmtD0n.css';
import NcActionButton from "./Components/NcActionButton.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-YZjkAQfi.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import NcActionCheckbox from "./Components/NcActionCheckbox.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-Dffj2gx5.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import NcActionRadio from "./Components/NcActionRadio.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-jYBYK6WE.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import NcActionTextEditable from "./Components/NcActionTextEditable.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-C4K-sTYm.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-hx60VxfZ.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-C5x4p-eV.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-JGpx1LjC.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import NcAppNavigationNew from "./Components/NcAppNavigationNew.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-U7nmcavB.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-Ak-Cq3nx.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-DtpUeFhv.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-Dgqy88lj.mjs";
import NcAppSettingsSection from "./Components/NcAppSettingsSection.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-CCL2-_-5.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-CLQ7_AQw.mjs";
import { u } from "./chunks/NcAvatar-CLQ7_AQw.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-lCjBkeeU.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-LgHb45DJ.mjs";
import NcButton from "./Components/NcButton.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-BU-MnU4U.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-Csni5btL.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-19JdVR99.mjs";
import { N as NcContent } from "./chunks/NcContent-D2roywh0.mjs";
import NcCounterBubble from "./Components/NcCounterBubble.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-eYMkaNge.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-BtIXF3nP.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-D63dAM9i.mjs";
import { u as u2 } from "./chunks/NcDateTime-D63dAM9i.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-VincZ0XS.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-JvyN3X6S.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-C5QwBqju.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-Da6Ob-6t.mjs";
import { N as NcHighlight } from "./chunks/index-CsogA-K5.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-Ckqpz-vm.mjs";
import NcInputField from "./Components/NcInputField.mjs";
import { N as NcListItem } from "./chunks/NcListItem-0EnLrbng.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-Bw6Wddoz.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-U7jnnuI6.mjs";
import { N as NcPopover } from "./chunks/NcPopover-VxUr4c6P.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-CZtllSde.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-TaYxpT6y.mjs";
import { N as NcMentionBubble } from "./chunks/index-DbA2OZyf.mjs";
import { r } from "./chunks/index-DbA2OZyf.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-Jk627HvF.mjs";
import { N as NcRichText } from "./chunks/NcRichText-rgX1D4Mv.mjs";
import { N, h, d, i, b, r as r2, c, a } from "./chunks/index-BwyQ2N-M.mjs";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a as a2, g, b as b2, c as c2, d as d2, s } from "./chunks/referencePickerModal-X5iEJq4e.mjs";
import "unist-util-visit";
import "unist-builder";
import "@nextcloud/router";
import "@nextcloud/axios";
import "@nextcloud/sharing/public";
import "@nextcloud/auth";
/* empty css                                                                            */
import { N as NcSelect } from "./chunks/NcSelect-VXa9BD3h.mjs";
import { N as NcTextField } from "./chunks/NcTextField-DCDVcnqT.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-Bhy7wcoT.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-CnMksmUz.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-6NUV0AUU.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-HExFhUqF.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-BvSwvGmQ.mjs";
import NcTextArea from "./Components/NcTextArea.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-CTNhHwMc.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-CT56m7hy.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-Bw4HYlgZ.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { E, a as a3, e, g as g2, s as s2 } from "./chunks/emoji-V6ytyzoR.mjs";
import { u as u3 } from "./chunks/usernameToColor-BlQigKGC.mjs";
import { directive } from "./Directives/Focus.mjs";
import { directive as directive$1 } from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a2 as anyLinkProviderId,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e as emojiSearch,
  g2 as getCurrentSkinTone,
  g as getLinkWithPicker,
  b2 as getProvider,
  c2 as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  d as isCustomPickerElementRegistered,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  b as registerCustomPickerElement,
  r2 as registerWidget,
  c as renderCustomPickerElement,
  a as renderWidget,
  r as richEditor,
  d2 as searchProvider,
  s2 as setCurrentSkinTone,
  s as sortProviders,
  u2 as useFormatDateTime,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  u3 as usernameToColor
};
